<script setup>
import Icon from 'next/icon/Icon.vue';
import { computed } from 'vue';
import { useSidebarContext } from './provider';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
});

const { isConversationSidebar } = useSidebarContext();
const shouldShowLeadingIcon = computed(() => {
  if (!props.icon) return false;
  if (!isConversationSidebar?.value) return true;
  return props.label === 'Channels' || props.label === 'Labels';
});
</script>

<template>
  <div
    class="flex items-center gap-2 px-2 py-1.5 rounded-lg h-8 select-none pointer-events-none wlab-sidebar-separator"
  >
    <Icon v-if="shouldShowLeadingIcon" :icon="icon" class="size-4" />
    <span class="text-sm font-medium leading-5 flex-grow">
      {{ label }}
    </span>
  </div>
</template>

<style>
.wlab-sidebar-separator,
.wlab-sidebar-separator *,
.wlab-sidebar-separator span,
.wlab-sidebar-separator .text-xs,
.wlab-sidebar-separator .text-sm {
  font-family: 'Excon', sans-serif !important;
  font-size: 12px !important;
}

/* 亮色主题 - 黑色 */
body:not(.dark) .wlab-sidebar-separator,
body:not(.dark) .wlab-sidebar-separator * {
  color: #000000 !important;
}

/* 暗色主题 - 白色 */
body.dark .wlab-sidebar-separator,
body.dark .wlab-sidebar-separator * {
  color: #ffffff !important;
}
</style>
